<template>
	<ja-modal v-if="formData" :show="show" class="add-simulation-modal">
		<ja-close-button name="close" @click.native="closeModal"></ja-close-button>

		<div class="modal-content">
			<perfect-scrollbar
				class="scrollbar"
				:options="{ suppressScrollY: showAddStudentSimModal }"
				:watch-options="true"
			>
				<h4>{{ $t('general') }}</h4>

				<div class="grid">
					<div class="grid-row-2">
						<ja-dropdown
							v-model="formData.simulationType"
							:label="$t('simulationTypeLbl')"
							:options="simulationTypes"
							name="simulationType"
							required
							:disabled="
								(simulation && !!simulation.simulationType) || isEducator
							"
							@input="updateTemplates"
						></ja-dropdown>
						<ja-dropdown
							v-model="formData.selectedTemplate"
							:label="$t('templateLbl')"
							:options="templates"
							:disabled="!enabledTemplateName || isEducator"
							name="template"
							required
						></ja-dropdown>
					</div>
					<div class="grid-row-2">
						<ja-input
							v-model="formData.sessionName"
							:label="$t('simulationLbl')"
							name="sessionName"
							required
							:disabled="isEducator"
						></ja-input>
						<ja-input
							v-model="formData.bCRMClassNumber"
							:label="$t('bcrmLbl')"
							:disabled="true"
							name="bCRMClassNumber"
						></ja-input>
					</div>
					<div class="grid-row-2">
						<ja-input
							v-model="formData.programName"
							:label="$t('programLbl')"
							:disabled="true"
							name="programName"
						></ja-input>
						<ja-date-input
							v-model="formData.startDate"
							:label="$t('simStartDateLbl')"
							:min-date="minStartDate"
							name="startDate"
							required
							:disabled="isEducator"
						></ja-date-input>
					</div>
					<div class="grid-row-2">
						<ja-date-input
							v-model="formData.endDate"
							:label="$t('simEndDateLbl')"
							:min-date="minEndDate"
							name="endDate"
							required
							:disabled="isEducator"
						></ja-date-input>
					</div>
					<ja-toggle-switch
						id="replayOption"
						v-model="formData.isReplayOptionEnabled"
						:disabled="!createMode && !simulation.isActive"
					>
						{{ $t('replayOption') }}
					</ja-toggle-switch>

					<ja-toggle-switch
						id="completeLifeStage"
						v-model="formData.isCompleteLifeStageOptionEnabled"
						:disabled="!createMode && !simulation.isActive"
					>
						{{ $t('completeLifeStageOption') }}
					</ja-toggle-switch>
					<ja-toggle-switch
						id="creditCardEnable"
						v-model="formData.isCreditCardEnable"
					>
						{{ $t('creditCard') }}
					</ja-toggle-switch>
				</div>
				<h4>{{ $t('schoolDetails') }}</h4>
				<div class="grid">
					<div class="grid-row-2 align-bottom">
						<ja-input
							v-model="formData.school"
							:label="$t('schoolLbl')"
							:disabled="true"
							name="school"
						></ja-input>
						<ja-input
							v-model="formData.reducedLunchPercentage"
							:is-number-input="true"
							:label="$t('lunchLbl')"
							name="reducedLunchPercentage"
							:disabled="isEducator"
						></ja-input>
					</div>
				</div>
				<h4>{{ $t('savingDetails') }}</h4>
				<div class="grid">
					<div class="grid-row-2 align-bottom">
						<ja-input
							v-model="formData.percentageOfNmiToSavings"
							:is-number-input="true"
							:label="$t('percentageOfNmiToSavings')"
							name="percentageOfNmiToSavings"
						></ja-input>
					</div>
				</div>
				<!-- Educatiors' List  START-->
				<div v-if="userSimulations && userSimulations.educators">
					<h4>
						{{ $t('educators') }} ({{ userSimulations.educators.length }})
					</h4>
					<div
						v-for="educator in userSimulations.educators"
						:key="educator.id"
						class="student-row"
					>
						<div class="student-column">
							<h5>{{ $t('firstName') }}</h5>
							<div class="body-text-1" name="educatorFirstName">
								{{ educator.user.firstName }}
							</div>
						</div>
						<div class="student-column">
							<h5>{{ $t('lastName') }}</h5>
							<div class="body-text-1" name="educatorLastName">
								{{ educator.user.lastName }}
							</div>
						</div>
						<div class="student-column-grow column-email">
							<h5>{{ $t('email') }}</h5>
							<div class="body-text-1" name="educatorEmail">
								{{ educator.user.emailAddress }}
							</div>
						</div>
					</div>
				</div>
				<!-- Educatiors' List  END-->

				<!-- Volunteers' List  START-->
				<div v-if="userSimulations && userSimulations.volunteers">
					<h4>
						{{ $t('volunteers') }} ({{ userSimulations.volunteers.length }})
					</h4>
					<div
						v-for="volunteer in userSimulations.volunteers"
						:key="volunteer.id"
						class="student-row"
					>
						<div class="student-column">
							<h5>{{ $t('firstName') }}</h5>
							<div class="body-text-1" name="volunteerFirstName">
								{{ volunteer.user.firstName }}
							</div>
						</div>
						<div class="student-column">
							<h5>{{ $t('lastName') }}</h5>
							<div class="body-text-1" name="volunteerLastName">
								{{ volunteer.user.lastName }}
							</div>
						</div>
						<div class="student-column-grow column-email">
							<h5>{{ $t('email') }}</h5>
							<div class="body-text-1" name="volunteerEmail">
								{{ volunteer.user.emailAddress }}
							</div>
						</div>
					</div>
				</div>
				<!-- Volunteers' List  END-->

				<!-- Students' List  START-->
				<div v-if="students && !createMode">
					<h4 class="students-head">
						{{ $t('students') }} ({{ paginationData.recordsCount }})
						<ja-button
							v-if="isActiveSimulation"
							name="exportStudentsEnrollment"
							class="btn export-stundents-btn transparent body-text-1"
							:disabled="!simulation.hasCsvData"
							@click.native="exportStudentsEnrollment()"
						>
							{{ $t('exportStudentsEnrollment') }}
						</ja-button>
						<ja-add-button
							v-if="isActiveSimulation"
							:simulation="simulation"
							@click.native="openModalAddStudentSim()"
						>
							{{ $t('addStudents') }}
						</ja-add-button>
					</h4>
					<div
						v-for="student in paginatedStudents[paginationData.currentPage - 1]"
						:key="student.id"
						class="student-row"
					>
						<div class="student-column">
							<h5>{{ $t('firstName') }}</h5>
							<div class="body-text-1" name="studentFirstName">
								{{ student.firstName }}
							</div>
						</div>
						<div class="student-column">
							<h5>{{ $t('lastName') }}</h5>
							<div class="body-text-1" name="studentLastName">
								{{ student.lastName }}
							</div>
						</div>
						<div class="student-column-grow column-email">
							<h5>{{ $t('email') }}</h5>
							<div class="body-text-1" name="studentEmail">
								{{ student.email }}
							</div>
						</div>
						<div class="student-column column-last-login">
							<h5>{{ $t('lastLogin') }}</h5>
							<div class="body-text-1">
								<div v-if="student && student.dateOfLastLogin">
									{{ student.dateOfLastLogin | dateFormatNumeric }}
								</div>
							</div>
						</div>
						<div class="student-column-right">
							<div class="student-delete-button">
								<svgicon
									:original="true"
									name="delete"
									@click.stop="showDeleteModal(student)"
								></svgicon>
							</div>
						</div>
					</div>
					<ja-pagination
						:data-per-page="paginationData.recordsPerPage"
						:data-count="paginationData.recordsCount"
						:current="paginationData.currentPage"
						@changePage="paginationData.currentPage = $event || 1"
					></ja-pagination>
				</div>
				<div v-else>
					<h4 class="students-head">{{ $t('students') }} (0)</h4>
				</div>

				<ja-add-student-sim-modal
					v-if="showAddStudentSimModal"
					:show="showAddStudentSimModal"
					:simulation="simulation"
					:students="students"
					@closeModalAddStudentSim="onModalAddStudentSimClose"
				></ja-add-student-sim-modal>
				<ja-confirm-modal
					class="deeper-level"
					:confirm-text="$t('remove')"
					:show="confirmModalData.isVisible"
					@cancel="closeDeleteModal()"
					@closeModal="closeDeleteModal()"
					@confirm="confirmStudentDeletion()"
				>
					{{ $t('studentDeleteConfirmation') }}
				</ja-confirm-modal>

				<div class="button-wrapper">
					<ja-button
						v-if="!createMode"
						class="small"
						name="saveSimForm"
						:disabled="disabledEditButton"
						@click.native="saveForm"
						>{{ $t('save') }}</ja-button
					>
					<ja-button
						v-else
						class="small"
						name="saveSimForm"
						:disabled="requestMade || !requiredFieldsPopulated"
						@click.native="addSimulation"
						>{{ $t('save') }}
					</ja-button>

					<ja-button
						class="small outlined"
						name="resetSimForm"
						@click.native="closeModal"
						>{{ $t('cancel') }}</ja-button
					>
				</div>
			</perfect-scrollbar>
		</div>
	</ja-modal>
</template>
<script>
const upperOnSiteSimType_ID = 1;

import Modal from '@/components/Modal/Modal';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import StudentsService from '@/services/StudentsService';
import { isCloudEnvironment } from '@/helpers/environment/useEnvConfig';
import { Button, CloseButton, ToggleSwitch } from '@ui';
import { DateInput, Input, Dropdown } from '@ui/form';
import gql from 'graphql-tag';
import AddButton from '../elements/AddButton';
import AddStudentSimModal from './AddStudentSimModal';
import { AdminFacility, DateFormat } from '@/mixins';
import { convertDateTimeToUTC } from '@/helpers/utils';
import { chunk } from 'lodash';
import Pagination from '@/components/AdminSection/elements/Pagination';
import dayjs from 'dayjs';
import { downloadCsvFile } from '@/helpers/utils';

export default {
	components: {
		jaInput: Input,
		jaDropdown: Dropdown,
		jaButton: Button,
		jaDateInput: DateInput,
		jaModal: Modal,
		jaAddButton: AddButton,
		jaAddStudentSimModal: AddStudentSimModal,
		jaCloseButton: CloseButton,
		jaConfirmModal: ConfirmModal,
		jaToggleSwitch: ToggleSwitch,
		jaPagination: Pagination
	},
	mixins: [AdminFacility, DateFormat],

	props: {
		show: {
			type: Boolean,
			default: false
		},
		simulation: {
			type: Object,
			default: null
		},
		facilities: {
			type: Array,
			required: true
		},
		simulationTypes: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			educators: [],
			volunteers: [],
			userSimulations: [],
			maxHours: 24,
			maxMinutes: 60,
			educatorID: '5',
			volunteerID: '6',
			requestMade: false,
			showAddStudentSimModal: false,
			formData: null,
			studentsBlank: {},
			simulationTypeByDefault: 'AdvancedVirtual',
			simulationStartHour: 0,
			simulationEndHour: 23,
			templates: [],
			isSimulationOnsite: false,
			confirmModalData: {
				isVisible: false,
				data: null
			},
			paginatedStudents: [],
			paginationData: {
				currentPage: 1,
				recordsPerPage: 15,
				recordsCount: 0
			}
		};
	},
	computed: {
		disabledEditButton() {
			if (!isCloudEnvironment) {
				return true;
			} else {
				return this.requestMade || !this.requiredFieldsPopulated;
			}
		},
		umsUpperVirtualSimulationTypeProgramId() {
			return this.$store.getters.programIDByDefault;
		},
		minEndDate() {
			const today = dayjs();

			// Get Today as minimum End Date.
			let minEndDate = today;

			const startDate = dayjs(this.formData.startDate);

			// if We have start date then use it as minimum endDate
			if (this.formData.startDate && !today.isAfter(startDate)) {
				minEndDate = startDate.add(1, 'day');
			}

			// DateInput component works with native Date so it expects Date object
			return minEndDate.toDate();
		},
		maxVisitStartDate() {
			let maxVisitStartDate = dayjs();
			const formEndDate = dayjs(this.formData.endDate);

			if (this.formData.endDate && formEndDate.isAfter(maxVisitStartDate)) {
				maxVisitStartDate = formEndDate;
			}

			// DateInput component works with native Date so it expects Date object
			return maxVisitStartDate.toDate();
		},
		minVisitEndDate() {
			let minVisitEndDate = new Date();

			if (this.formData.startDate) {
				minVisitEndDate = this.formData.startDate;
			}

			if (
				this.formData.visitStartDate &&
				this.formData.visitStartDate > this.formData.startDate
			) {
				minVisitEndDate = this.formData.visitStartDate;
			}

			return minVisitEndDate;
		},
		simulationTypeIsOnsite() {
			if (this.formData) {
				return this.formData.simulationType === upperOnSiteSimType_ID;
			}
			return null;
		},
		simStartDate() {
			if (this.formData) {
				return this.formData.startDate;
			}
			return null;
		},
		simEndDate() {
			if (this.formData) {
				return this.formData.endDate;
			}
			return null;
		},
		allHours() {
			return Array(this.maxHours)
				.fill()
				.map((item, i) => {
					return {
						name: i,
						value: i
					};
				});
		},
		isActiveSimulation() {
			if (!this.simEndDate) {
				return this.simulation.isActive;
			}

			return convertDateTimeToUTC() <= convertDateTimeToUTC(this.simEndDate);
		},
		allMinutes() {
			return Array(this.maxMinutes)
				.fill()
				.map((item, i) => {
					return {
						name: i,
						value: i
					};
				});
		},
		minStartDate() {
			const minStartDate = dayjs();
			// compensate for +1 day in the component itself
			return minStartDate.subtract(1, 'day').toDate();
		},
		createMode() {
			return !this.simulation;
		},
		requiredFieldsPopulated() {
			return (
				this.formData &&
				this.formData.selectedTemplate >= 0 &&
				this.formData.startDate &&
				this.formData.endDate &&
				this.formData.simulationType >= 0 &&
				this.formData.facility >= 0 &&
				this.formData.sessionName
			);
		},
		enabledTemplateName() {
			const isEnabledByFormData =
				this.formData.facility !== -1 &&
				this.formData.simulationType !== -1 &&
				this.templates.length !== 0;

			let isEnabledByStudents = true;
			if (this.students && this.students.length) {
				// The first who has avatar selected
				isEnabledByStudents = !this.students.some(s => s.avatarId);
			}

			return isEnabledByFormData && isEnabledByStudents;
		},
		visitDatesAreDisabled() {
			return !this.formData.startDate || !this.formData.endDate;
		},
		simulationType() {
			if (this.formData) {
				return this.formData.simulationType;
			}
			return null;
		},
		isEducator() {
			return this.userData.roleId == this.educatorID;
		}
	},
	watch: {
		selectedFacilityId(value) {
			this.formData.facility = value;
		},
		'formData.startDate': function(newValue) {
			if (!newValue) {
				return;
			}

			const startAsDate = new Date(newValue);
			const endAsDate = new Date(this.formData.endDate);

			// TODO: Needs to be simplified with a date library
			// Set the hours to 0, so that we can compare only the dates
			if (startAsDate.setHours(0, 0, 0, 0) >= endAsDate.setHours(0, 0, 0, 0)) {
				this.formData.endDate = new Date(startAsDate);
				this.formData.endDate.setDate(startAsDate.getDate() + 1);
			}
		},
		'formData.visitStartDate': function(newValue) {
			const valueAsDate = new Date(newValue);

			if (valueAsDate > this.formData.visitEndDate) {
				this.formData.visitEndDate = new Date(valueAsDate);
			}
		},
		simulation() {
			this.setupModalData();
		},
		simulationType: function(newValue, oldValue) {
			if (newValue !== oldValue && oldValue === upperOnSiteSimType_ID) {
				this.formData.visitStartDate = null;
				this.formData.visitEndDate = null;
				this.formData.visitStartMinutes = null;
				this.formData.visitEndMinutes = null;
				this.formData.visitStartHour = null;
				this.formData.visitEndHour = null;
			}
			if (newValue >= 0) {
				this.isSimulationOnsite = this.simulationTypes[newValue].value
					.toLowerCase()
					.includes('onsite');
			} else {
				this.isSimulationOnsite = false;
			}
		},
		simStartDate(newValue) {
			if (newValue > this.formData.visitStartDate) {
				this.formData.visitStartDate = null;
			}
		},
		simEndDate(newValue) {
			if (newValue < this.formData.visitEndDate) {
				this.formData.visitEndDate = null;
			}
		}
	},
	mounted() {
		if (this.simulation) {
			this.setupModalData();
			this.getTemplates().then(() => {
				this.$set(
					this.formData,
					'selectedTemplate',
					this.templates.findIndex(
						template =>
							template.value == this.simulation.upperSimulationTemplate_ID
					)
				);
			});
		} else {
			this.blankSimulationData();
		}
	},
	methods: {
		setupModalData() {
			const formData = {
				sessionName: this.simulation.sessionName,
				bCRMClassNumber: this.simulation.bCRMClassNumber,
				programName: this.simulation.programName,
				school: this.simulation.school,
				facility: this.selectedFacilityId
			};

			formData.simulationType = this.simulationTypes.findIndex(
				simType => simType.value == this.simulation.simulationType
			);

			formData.startDate = this.simulation.startDate
				? new Date(this.simulation.startDate)
				: null;
			formData.endDate = this.simulation.endDate
				? new Date(this.simulation.endDate)
				: null;
			formData.visitStartDate = this.simulation.visitStartDate
				? new Date(this.simulation.visitStartDate)
				: null;
			formData.visitEndDate = this.simulation.visitEndDate
				? new Date(this.simulation.visitEndDate)
				: null;

			if (formData.visitStartDate) {
				formData.visitStartHour = formData.visitStartDate.getHours();
				formData.visitStartMinutes = formData.visitStartDate.getMinutes();
			} else {
				formData.visitStartHour = 0;
				formData.visitStartMinutes = 0;
			}

			if (formData.visitEndDate) {
				formData.visitEndHour = formData.visitEndDate.getHours();
				formData.visitEndMinutes = formData.visitEndDate.getMinutes();
			} else {
				formData.visitEndHour = 0;
				formData.visitEndMinutes = 0;
			}

			formData.reducedLunchPercentage = this.simulation.reducedLunchPercentage;

			formData.percentageOfNmiToSavings = this.simulation.percentageOfNmiToSavings;

			formData.isReplayOptionEnabled = !this.createMode
				? this.simulation.isReplayOptionEnabled
				: true;

			formData.isCompleteLifeStageOptionEnabled = !this.createMode
				? this.simulation.isCompleteLifeStageOptionEnabled
				: true;

			formData.isCreditCardEnable = !this.createMode
				? this.simulation.isCreditCardEnable
				: true;

			formData.externalId = this.simulation.externalId;
			this.formData = formData;
		},
		updateTemplates() {
			this.templates = [];
			this.formData.selectedTemplate = -1;
			this.getTemplates();
		},
		blankSimulationData() {
			this.formData = {
				selectedTemplate: -1,
				facility: this.selectedFacilityId,
				simulationType: -1,
				visitStartDate: null,
				startDate: null,
				endDate: null,
				visitEndDate: null,
				visitStartHour: 0,
				visitEndHour: 0,
				visitStartMinutes: 0,
				visitEndMinutes: 0,
				reducedLunchPercentage: null,
				sessionName: null,
				bCRMClassNumber: null,
				programName: null,
				school: null,
				percentageOfNmiToSavings: 20,
				isReplayOptionEnabled: true,
				isCompleteLifeStageOptionEnabled: true,
				isCreditCardEnable: true
			};
		},
		getSimulationDates() {
			const dates = {
				visitStartDate: null,
				visitEndDate: null,
				startDate: null,
				endDate: null
			};

			if (this.isSimulationOnsite) {
				if (this.formData.visitStartDate) {
					this.formData.visitStartDate.setHours(this.formData.visitStartHour);
					this.formData.visitStartDate.setMinutes(
						this.formData.visitStartMinutes
					);

					dates.visitStartDate = this.formData.visitStartDate.toISOString();
				}
				if (this.formData.visitEndDate) {
					this.formData.visitEndDate.setHours(this.formData.visitEndHour);
					this.formData.visitEndDate.setMinutes(this.formData.visitEndMinutes);

					dates.visitEndDate = this.formData.visitEndDate.toISOString();
				}
			}

			dates.startDate = this.formatStartDate(this.formData.startDate);
			dates.endDate = this.formatEndDate(this.formData.endDate);

			return dates;
		},

		getSimulationData() {
			const simulationData = {};
			const simulationDates = this.getSimulationDates();

			if (this.simulation) {
				simulationData.id = this.simulation.id;
			}

			simulationData.visitStartDate = simulationDates.visitStartDate;
			simulationData.visitEndDate = simulationDates.visitEndDate;
			simulationData.startDate = simulationDates.startDate;
			simulationData.endDate = simulationDates.endDate;

			simulationData.upperSimulationTemplate_ID = this.templates[
				this.formData.selectedTemplate
			].value;
			simulationData.facility_ID = this.selectedFacilityId;
			simulationData.simulationType = this.simulationTypes[
				this.formData.simulationType
			].value;

			simulationData.facility = this.selectedFacility.name;
			simulationData.reducedLunchPercentage = parseFloat(
				this.formData.reducedLunchPercentage
			);
			simulationData.programID = this.simulation
				? this.simulation.programID
				: this.umsUpperVirtualSimulationTypeProgramId;
			simulationData.programName = this.simulation
				? this.simulation.programName
				: '';
			simulationData.school = this.formData.school;
			simulationData.sessionName = this.formData.sessionName;
			simulationData.percentageOfNmiToSavings = parseInt(
				this.formData.percentageOfNmiToSavings
			);

			simulationData.isReplayOptionEnabled = this.formData.isReplayOptionEnabled;

			simulationData.isCompleteLifeStageOptionEnabled = this.formData.isCompleteLifeStageOptionEnabled;

			simulationData.isCreditCardEnable = this.formData.isCreditCardEnable;
			simulationData.externalId = this.formData.externalId;

			return simulationData;
		},

		async saveForm() {
			if (this.requiredFieldsPopulated) {
				this.requestMade = true;

				const response = await this.$apollo
					.mutate({
						mutation: gql`
							mutation($update: SimulationInputObjectGraphType!) {
								updateIgnoreNullValuesSimulation(update: $update) {
									id
								}
							}
						`,
						variables: {
							update: this.getSimulationData()
						}
					})
					.catch(() => {
						this.requestMade = false;
					});

				if (response.data) {
					this.requestMade = false;
					this.closeModal();
				}
			}
		},

		async addSimulation() {
			if (this.requiredFieldsPopulated) {
				this.$store.commit('setLoading', true);

				const response = await this.$apollo.mutate({
					mutation: gql`
						mutation AddSimulation($add: SimulationAddInputObjectGraphType!) {
							addSimulation(add: $add) {
								id
							}
						}
					`,
					variables: {
						add: this.getSimulationData()
					}
				});
				if (response.data) {
					this.$store.commit('setLoading', false);
					this.$emit('refetchSimulations');
					this.closeModal();
				}
			}
		},
		closeModal() {
			this.blankSimulationData();
			this.$emit('closeModal');
		},
		exportStudentsEnrollment() {
			if (this.simulation.studentsCsv) {
				const fileName = `Student simulation-${this.simulation.id}`;
				return downloadCsvFile(this.simulation.studentsCsv, fileName);
			}
		},
		openModalAddStudentSim() {
			this.showAddStudentSimModal = true;
			this.scrollToModalTitle();
		},
		onModalAddStudentSimClose() {
			this.showAddStudentSimModal = false;
			this.refetchSimulationStudents();
		},
		refetchSimulationStudents() {
			if (this.$apollo.queries.students) {
				this.$apollo.queries.students.refetch();
			}
		},
		scrollToModalTitle() {
			this.$refs.modalFirstDropdown.$el.scrollIntoView({
				block: 'center'
			});
		},
		async getTemplates() {
			const filters = [];

			filters.push('IsActive=true');
			if (this.formData.facility >= 0) {
				filters.push(`facility_ID=${this.formData.facility}`);
			}

			if (this.formData.simulationType >= 0) {
				filters.push(
					`simulationType=${
						this.simulationTypes[this.formData.simulationType].id
					}`
				);
			}
			const response = await this.$apollo.query({
				query: gql`
					query templates($where: String!) {
						cmsUpperSimulationTemplates: cmsUpperSimulationTemplates(
							where: $where
						) {
							upperSimulationTemplate_ID
							templateName
							facility_ID
						}
					}
				`,

				variables: {
					where: filters.join('&&')
				},
				fetchPolicy: 'no-cache'
			});

			if (response.data && response.data.cmsUpperSimulationTemplates) {
				const templates = [];
				const data = response.data;
				if (data && data.cmsUpperSimulationTemplates) {
					data.cmsUpperSimulationTemplates.forEach(template => {
						templates.push({
							name: template.templateName,
							value: template.upperSimulationTemplate_ID
						});
					});
				}

				this.templates = templates;
			}
		},
		showDeleteModal(student) {
			this.confirmModalData.isVisible = true;

			// set student in question for later usage
			this.confirmModalData.data = student;
		},
		closeDeleteModal() {
			this.confirmModalData = {
				isVisible: false,
				data: null
			};
		},
		confirmStudentDeletion() {
			this.$store.commit('setLoading', true);
			// get only the email because we need only that here
			// whole object is set in data because
			// we can use other properties of the object if needed
			const { email } = this.confirmModalData.data;

			// fetch all ids for user in question by their email
			StudentsService.getStudentsIdsByUserData({
				email: email,
				simulationId: this.simulation.id
			}).then(({ data }) => {
				// remap the data because it is retuned as array of objects
				// but we need array of Ids
				const ids = data.students.map(element => element.id);

				// remove all students with fetched ids.
				StudentsService.removeStudentsFromSimulation(ids).then(() => {
					this.confirmModalData.isVisible = false;
					this.$store.commit('setLoading', false);
					this.refetchSimulationStudents();
				});
			});
		}
	},
	apollo: {
		students: {
			query: gql`
				query students($where: String!, $uniqueBy: String!) {
					students(where: $where, uniquefield: $uniqueBy) {
						id
						dateOfLastLogin
						firstName
						lastName
						email
						avatarId
					}
					studentsCount: getCountStudent(where: $where, uniquefield: $uniqueBy)
				}
			`,
			variables() {
				return {
					where: `simulationId  = ${this.simulation.id}`,
					uniqueBy: 'email'
				};
			},
			skip() {
				return !this.simulation;
			},
			update({ studentsCount, students }) {
				this.paginationData.recordsCount = studentsCount;

				this.paginatedStudents = chunk(
					students,
					this.paginationData.recordsPerPage
				);
				return students;
			},
			fetchPolicy: 'no-cache'
		},
		userSimulations: {
			query: gql`
				query userSimulations($where: String!) {
					userSimulations: userSimulations(where: $where) {
						user {
							roleId
							firstName
							lastName
							emailAddress
						}
					}
				}
			`,
			variables() {
				return {
					where: this.simulation
						? `SimulationId = ${this.simulation.id} && (User.RoleId="${this.educatorID}" || User.RoleId="${this.volunteerID}")`
						: ''
				};
			},
			skip() {
				return !this.simulation;
			},
			fetchPolicy: 'no-cache',
			update(data) {
				let userSimulations = data.userSimulations;

				let result = {
					educators: userSimulations.filter(
						sim => sim.user.roleId === this.educatorID
					),
					volunteers: userSimulations.filter(
						sim => sim.user.roleId === this.volunteerID
					)
				};

				return result;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.add-simulation-modal {
	::v-deep .modal {
		margin: auto;
		bottom: 0;
		min-height: 240px;
		max-height: 768px;
	}
	::v-deep.modal-content {
		border-radius: 8px;
	}
	.close-button {
		background-color: $font-blue;
		position: absolute;
		height: 38px;
		width: 38px;
		right: 16px;
		top: 16px;
		outline: 0;
		border: 0;
		background-color: $container-bgcolor;
		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				svg {
					fill: $hover-state;
				}
			}
		}

		svg {
			fill: $primary-state;
		}
	}

	.modal-content {
		.scrollbar {
			max-height: 720px;
		}
		width: 100%;
		padding-top: 64px;
		display: flex;
		flex-direction: column;
		text-align: left;
		background-color: $container-bgcolor;
		border: 1px solid $container-border;

		h4 {
			margin: 16px;
		}
		.students-head {
			display: flex;
			justify-content: space-between;
		}

		.grid {
			display: flex;
			flex-direction: column;
			padding: 0 32px 32px 32px;
			margin-bottom: 16px;
			border-bottom: 1px solid $container-border;

			.grid-row-1 {
				display: flex;
				margin-bottom: 16px;
				> * {
					flex: 0 0 100%;
				}
			}

			.grid-row-2 {
				display: flex;
				align-items: flex-start;

				&:not(:last-child) {
					margin-bottom: 16px;
				}

				> * {
					flex: 0 0 calc(50% - 8px);

					&:first-child {
						margin-right: 16px;
					}
				}
				&.align-bottom {
					align-items: flex-end;
				}
			}

			.grid-col-3 {
				display: flex;
				align-items: flex-end;

				> :first-child {
					margin-right: 16px;
				}

				.grid-cell-2 {
					flex: 0 0 calc(66.66% - 8px);
				}

				.grid-cell-1 {
					flex: 0 0 calc(33.33% - 8px);
				}
			}
		}

		.student-row {
			display: flex;
			width: 100%;
			padding: 16px 32px;
			border-bottom: 1px solid $container-border;

			.student-column {
				width: 20%;
				padding: 0 2px;
				word-break: break-all;

				&:last-of-type {
					width: 5%;
				}

				&.column-last-login {
					width: 15%;
					margin: 0 10px;
				}
			}

			.student-column-right {
				display: flex;
				align-items: center;
			}

			.student-column-grow {
				flex-grow: 1;
				word-break: break-word;
				margin-right: 20px;

				&.column-email {
					width: 40%;
				}
			}
			h5 {
				color: $font-dark;
				margin-bottom: 4px;
			}
		}

		.student-row:nth-child(odd) {
			background-color: #f2fbff;
		}
		.button-wrapper {
			text-align: center;
			margin: 32px 0 64px 0;

			:first-child {
				margin-right: 16px;
			}
		}
	}

	.svg-icon {
		height: 24px;
		width: 24px;
		fill: $primary-state;
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
	}
}

.confirm-modal {
	.modal {
		bottom: auto !important;
		top: 25%;
	}
}

.export-stundents-btn {
	font-family: 'RobotoMedium';
	font-size: 18px;
}
</style>
